export function isValidUrl(url) {
	const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
	return urlRegex.test(url);
}

export function age18Calculate(birthdayCurrent)
{
  const nowDay = new Date();
  nowDay.setFullYear(nowDay.getFullYear() - 18);
  if (birthdayCurrent)
  {
	const birthday = new Date(birthdayCurrent);
	return birthday <= nowDay;
  }
  return false;
}